import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import * as enTranslations from "./locales/en"
import * as csTranslations from "./locales/cs"

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        debug: true,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        resources: {
            en: JSON.parse(JSON.stringify(enTranslations.default)),
            cs: JSON.parse(JSON.stringify(csTranslations.default))
            
        }
    });

export default i18n;